"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSplitDropdownProvider = void 0;
var react_1 = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var classnames_1 = __importDefault(require("classnames"));
var ButtonDropdown_scss_1 = __importDefault(require("./ButtonDropdown.scss"));
var ButtonSplitDropdownProvider = function (props) {
    var _a = (0, react_1.useState)(false), dropdownOpen = _a[0], setOpen = _a[1];
    var toggle = function () {
        setOpen(!dropdownOpen);
    };
    return (react_1.default.createElement(reactstrap_1.UncontrolledDropdown, { group: true, isOpen: dropdownOpen, toggle: toggle, disabled: props.disabled, className: "".concat((0, classnames_1.default)(props.disabled ? ButtonDropdown_scss_1.default["disabled"] : "", props.className), " ") },
        react_1.default.createElement(reactstrap_1.Button, { onClick: function () { return !props.disabled && props.onButtonClick(); }, className: (0, classnames_1.default)(ButtonDropdown_scss_1.default["au-btn-dropdown"], 'mr-0') }, props.label),
        react_1.default.createElement(reactstrap_1.DropdownToggle, { className: (0, classnames_1.default)(ButtonDropdown_scss_1.default["au-btn-dropdown"]), style: { padding: "8px 18px", zIndex: 0, marginLeft: 1 }, caret: true }),
        props.items && (react_1.default.createElement(reactstrap_1.DropdownMenu, { className: (0, classnames_1.default)(ButtonDropdown_scss_1.default["au-dropdownmenu"]) }, props.items.map(function (x, i) {
            return (react_1.default.createElement(reactstrap_1.DropdownItem, { key: i, onClick: x.onDrodownButtonClick, className: (0, classnames_1.default)(ButtonDropdown_scss_1.default["au-dropdownitem"], props.className) }, x.label));
        })))));
};
exports.ButtonSplitDropdownProvider = ButtonSplitDropdownProvider;
//# sourceMappingURL=ButtonSplitDropdown.js.map